import { sendWebsocketMessage } from '../../../../../../App';

export function addPositionBreakPriceFromChart(tradePlanId, price, symbol) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'addBreakPriceFromChart',
    value: { price, symbol },
  };
  sendWebsocketMessage(msg);
}
